import { useContext } from 'react';
import { EMPTY_OBJECT, AppContext, UserContext } from 'commons-ui';

import useService from '../utils/useService';
import {
	ADD_OFFER_ENDPOINT,
	BACK_OFFER_ENDPOINT,
	CLONE_OFFER_ENDPOINT,
	DETAILS_OFFER_ENDPOINT,
	EDIT_OFFER_ENDPOINT
} from '../../gstHelper';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog } = params;
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const { toggleIsDisabledField } = useService();
	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: EDIT_OFFER_ENDPOINT,
					state: {
						rowData,
						segmentList: action.segmentList
					}
				});
			};
		case 'clone':
			return () => {
				const filteredRowData = { segmentList: action.segmentList, mapValues: action.mapValues };
				history.push({
					pathname: CLONE_OFFER_ENDPOINT,
					state: {
						rowData,
						...filteredRowData
					}
				});
			};
		case 'offers':
			return () => {
				history.push({
					pathname: DETAILS_OFFER_ENDPOINT,
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				const filteredRowData = { segmentList: action.segmentList, mapValues: action.mapValues };
				history.push({
					pathname: ADD_OFFER_ENDPOINT,
					state: filteredRowData
				});
			};
		case 'back':
			return () => {
				history.push({
					pathname: BACK_OFFER_ENDPOINT
				});
			};
		case 'remove': {
			const toggleIsDisabled = () => {
				return toggleIsDisabledField(rowData, history, user, app, showAlert);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Remove from app?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
